/**
 * Who is signed in, and the token that says so.
 *
 * The seam is deliberately the same shape as `core-api`'s `TokenVerifier`: two
 * implementations, one interface, and nothing downstream knows which it has.
 * There it is "verify a signature or do not"; here it is "ask Firebase for a
 * token or mint the unsigned dev shape". Both ends of the wire therefore have
 * one place each where development differs from production, and the rest of both
 * programs is identical either way.
 */

export interface StaffUser {
  uid: string;
  email: string | null;
}

export interface AuthProvider {
  readonly kind: 'firebase' | 'fake';
  /** Null until the first `onChange`, then the signed-in user or null. */
  current(): StaffUser | null;
  signIn(email: string, password: string): Promise<void>;
  signOut(): Promise<void>;
  /**
   * The ID token, refreshed when asked. Returns null when nobody is signed in —
   * the `ApiClient` sends the request anyway and lets `core-api`'s `401` be the
   * authority on it, rather than this app inventing a second opinion about
   * whether a credential is good.
   */
  token(forceRefresh?: boolean): Promise<string | null>;
  onChange(listener: (user: StaffUser | null) => void): () => void;
}

export class AuthError extends Error {
  readonly reason: 'bad_credentials' | 'unavailable';
  constructor(reason: 'bad_credentials' | 'unavailable', message: string) {
    super(message);
    this.name = 'AuthError';
    this.reason = reason;
  }
}
